import { useMemo } from "react";
import activities from "../redux/activities";
import statuses from "../redux/statuses";
import { StateEnveloped } from "../redux/helpers";
import { Authentication } from "../models";
import { makeHookDeprecationWarn } from "../helpers/warnings";
import { useAuthenticationData, useAuthenticationStatus } from "../next/hooks";

export type AuthenticationHookResult = StateEnveloped<Authentication>;
export type AuthenticationHook = () => AuthenticationHookResult;

const deprecationWarn = makeHookDeprecationWarn("useAuthentication");

/**
 * @deprecated Use next.hooks.useAuthentication instead.
 */
const Hook: AuthenticationHook = () => {
  deprecationWarn();
  const data = useAuthenticationData();
  const status = useAuthenticationStatus();
  return useMemo(
    () => ({
      status: statuses[status],
      activity: activities.authenticating,
      data,
    }),
    [status, data],
  );
};

export default Hook;
